'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ifDeployedAndProduction = undefined;

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ifDeployedAndProduction = exports.ifDeployedAndProduction = function ifDeployedAndProduction(service) {
  return _enviro2.default.deployed(service) && _enviro2.default.getShort(service) === 'prod';
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/q/static-5.30/js/util/env.js
// module id = 1225
// module chunks = 3